import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MessageService, TreeNode } from 'primeng/api';
import { IdName } from '../domain/idname';
import { Configuration } from '../domain/configuration';
import { Totaling } from "../domain/totaling";
import * as _ from "lodash";
import { DynamicBackendConfigService } from './dynamic-backend-config.service';
import { AppConfigService } from './app-config.service';

@Injectable({
    providedIn: 'root'
})
export class AccountService {
    uriPath = "/api/lookup/accounts";
    uriAccountsPath = "/api/accountlookup";

    allAccountsTotalingsIds: number[];
    allAccountsTotalingRanges: Array<number[]>;

    uri = '';
    uriAccounts = '';

    apiUrl = '';
  
    constructor(
        private http: HttpClient,
        private messgeService: MessageService,
        private dynamicBackend : DynamicBackendConfigService,
        private appConfigService: AppConfigService
    ) {
        this.apiUrl = this.appConfigService.apiUrl;
     /* this.dynamicBackend.getApiUrl().subscribe(apiUrl => {
        this.uri = this.dynamicBackend.extractSecondURL(apiUrl ? `${apiUrl}${this.uriPath}` : this.uriPath);
        this.uriAccounts = this.dynamicBackend.extractSecondURL(apiUrl ? `${apiUrl}${this.uriAccountsPath}` : this.uriAccountsPath);
      });
      */
    }

    setAllAccountsTotalingsIds (totalings: Totaling[]) {
        this.allAccountsTotalingsIds = [];
        this.allAccountsTotalingRanges = [];

        console.log(totalings);

        totalings.forEach(totaling => {
            if (totaling.Names.includes("..")) {
                //it's a range
                var rangeIds = [];
                totaling.Ids.split("..").forEach(id => {
                    rangeIds.push(Number(id))
                })

                //range start - rangeIds[0], range end - rangeIds[1];
                this.allAccountsTotalingRanges.push(rangeIds);
            } else {
                //it's not a range
                totaling.Ids.split("|").forEach(id => {
                    this.allAccountsTotalingsIds.push(Number(id));
                })
            }
        });
    }

    getIds(what: IdName[]) {
        let retval: string = '';
        if (what) {
            what.forEach(a => (retval = retval + a.id + ','));

            retval = retval.substring(0, retval.length - 1);
        }

        return retval;
    }

    count(): Observable<number> {
        const companyId = JSON.parse(localStorage.getItem('currentCompany')).id;
        const countUri = `${this.apiUrl}${this.uriPath}/${companyId}/count`;
        return this.http.get<number>(countUri);
        
    }

    getAll(reportId: string, filter: IdName[]): Promise<TreeNode[]> {
        const getUri = `${this.apiUrl}${this.uriAccountsPath}/all-for-report-${reportId}`;
        const promise = this.http
            .get<TreeNode[]>(getUri)
            .toPromise();
        return promise;
    }

    getAllForFilter(reportId: string, filterIds: string): Promise<TreeNode[]> {
        filterIds = filterIds.length < 1 ? "null" : filterIds;
        const getUri = `${this.apiUrl}${this.uriAccountsPath}/all-for-filter-${reportId}/${filterIds}`;
        const promise = this.http
            .get<TreeNode[]>(getUri)
            .toPromise();
        return promise;
    }

    getAllForFilterList(reportId: string, filterIds: string): Promise<TreeNode[]> {
        filterIds = filterIds.length < 1 ? "null" : filterIds;
        const requestBody = { filterIds: filterIds, reportId: reportId };
        const getUri = `${this.apiUrl}${this.uriAccountsPath}/all-for-filter-list`;
        const promise = this.http
            .post<TreeNode[]>(getUri, requestBody, { headers: { "Content-Type": "application/json" } })
            .toPromise();
        return promise;
    }

    createTreeFor(ids: string): Promise<TreeNode[]> {
        const companyId = JSON.parse(localStorage.getItem('currentCompany')).id;
        const getUri = `${this.apiUrl}${this.uriAccountsPath}/create-tree-for/${ids}`;
        const promise = this.http.get<TreeNode[]>(getUri).toPromise();
        return promise;
    }

    createTreeForList(ids: string): Promise<TreeNode[]> {
        const getUri = `${this.apiUrl}${this.uriAccountsPath}/create-tree-for-list`;
        const requestBody = { ids: ids };
        const promise = this.http
            .post<TreeNode[]>(getUri, requestBody, { headers: { "Content-Type": "application/json" } })
            .toPromise();
    
        return promise;
    }

    getForLine(lineId: string): Promise<TreeNode[]> {
        const getUri = `${this.apiUrl}${this.uriAccountsPath}/included-for-line-${lineId}`;
        const promise = this.http
            .get<TreeNode[]>(getUri)
            .toPromise();
        return promise;
    }

    getExcluded(reportId: string, filter: IdName[]): Promise<TreeNode[]> {
        const getUri = `${this.apiUrl}${this.uriAccountsPath}/excluded-for-report-${reportId}`;
        const promise = this.http
            .get<TreeNode[]>(getUri)
            .toPromise();
        return promise;
    }

    getExcludedForLine(lineId: string): Promise<TreeNode[]> {
        const getUri = `${this.apiUrl}${this.uriAccountsPath}/excluded-for-line-${lineId}`;
        const promise = this.http
            .get<TreeNode[]>(getUri)
            .toPromise();
        return promise;
    }

    getIncluded(reportId: string, filter: IdName[]): Promise<TreeNode[]> {
        const getUri = `${this.apiUrl}${this.uriAccountsPath}/included-for-report-${reportId}`;
        const promise = this.http
            .get<TreeNode[]>(getUri)
            .toPromise();
        return promise;
    }

    getIncludedTree(reportId: string, filter: IdName[]): Promise<TreeNode[]> {
        const getUri = `${this.apiUrl}${this.uriAccountsPath}/included-for-report-tree/${reportId}`;
        const promise = this.http
            .get<TreeNode[]>(getUri)
            .toPromise();
        return promise;
    }

    children(reportId: string, parent: number): Promise<TreeNode[]> {
        const getUri = `${this.apiUrl}${this.uriPath}/${reportId}/${parent}`;
        const promise = this.http.get<TreeNode[]>(getUri).toPromise();
        return promise;
    }

    search(what: String): Promise<TreeNode[]> {
        const companyId = JSON.parse(localStorage.getItem('currentCompany')).id;
        const promise = this.http
            .get<TreeNode>(`${this.apiUrl}${this.uriPath}/${companyId}/search/${what}`)
            .toPromise()
            .then(data => data.children);
        return promise;
    }

    searchByList(reportId: string, what: IdName[]): Promise<TreeNode[]> {
        const promise = this.http
            .post<TreeNode>(`${this.apiUrl}${this.uriPath}/${reportId}/filter`, what)
            .toPromise()
            .then(data => data.children);
        return promise;
    }
}
